module.exports = __webpack_public_path__ + "img/project-cover9.cf0c2be3.jpg";